module.exports = __webpack_public_path__ + "static/ghanshyam-318388d99a9264a3afc14d8855f4e866.png";